import printJS from 'print-js';

export function printPickingList(id: 'PICKINGLISTCONTENT') {
  let styles = '';
  for (let index = 0; index < document.getElementsByTagName('style').length; index++) {
    const element = document.getElementsByTagName('style')[index];
    styles += element.outerHTML;
  }
  const table = document.getElementById(id).outerHTML;
  const printable = `<style>body{-webkit-print-color-adjust:exact !important;print-color-adjust:exact !important;}</style>${styles}${table}`;

  try {
    printJS({
      printable: printable,
      type: 'raw-html',
      onError: (e) => console.log(e)
    });
  } catch (error) {
    console.log(error);
  }
}
